import produce from 'immer'
import { assign, findIndex } from 'lodash'

import { areSameValue } from '../../../core/utils'

import {
  ASSIGN_BRAND_CURATION_TASK_USER,
  DELETE_FAKE_BRAND,
  FETCH_BRAND_CURATION_TASKS,
  UPDATE_BRAND_CURATION_TASK_PERSISTED_FILTERS,
} from '../action-types'
import { BRAND_CURATION_TASKS_INITIAL_STATE } from '../initial-states'

const brandCurationTasksReducer = (
  state = BRAND_CURATION_TASKS_INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    case FETCH_BRAND_CURATION_TASKS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          data: {},
        }),
      )

    case FETCH_BRAND_CURATION_TASKS.COMPLETE:
      return produce(state, nextState => {
        const results = action.payload.data.brandCurationTasks

        return assign(nextState, {
          isLoading: false,
          error: undefined,
          data: results,
        })
      })

    case FETCH_BRAND_CURATION_TASKS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error.message,
          data: {},
        }),
      )

    case FETCH_BRAND_CURATION_TASKS.CLEANUP:
      return { ...BRAND_CURATION_TASKS_INITIAL_STATE }

    case ASSIGN_BRAND_CURATION_TASK_USER.START:
      return produce(state, nextState => {
        const index = findIndex(state?.data?.result, ({ id }) =>
          areSameValue(id, action.payload.id),
        )

        assign(nextState.data?.result[index], {
          isLoading: true,
          error: undefined,
        })
      })

    case ASSIGN_BRAND_CURATION_TASK_USER.COMPLETE:
      return produce(state, nextState => {
        const { assignUserToBrandCurationTask: brandCurationTask } =
          action.payload.data

        const index = findIndex(state?.data?.result, ({ id }) =>
          areSameValue(id, brandCurationTask.id),
        )

        assign(nextState.data?.result[index], {
          ...brandCurationTask,
          isLoading: false,
          error: undefined,
        })
      })

    case ASSIGN_BRAND_CURATION_TASK_USER.FAIL:
      return produce(state, nextState => {
        const index = findIndex(state?.data?.result, ({ id }) =>
          areSameValue(id, action.payload.id),
        )

        assign(nextState.data?.result[index], {
          isLoading: false,
          error: action.error.message,
        })
      })

    case DELETE_FAKE_BRAND.START:
      return produce(state, nextState => {
        const index = findIndex(state?.data?.result, ({ brand }) =>
          areSameValue(brand.id, action.payload.id),
        )

        assign(nextState.data?.result[index], {
          isLoading: true,
          error: undefined,
        })
      })

    case DELETE_FAKE_BRAND.COMPLETE:
      return produce(state, nextState => {
        const index = findIndex(state?.data?.result, ({ brand }) =>
          areSameValue(brand.id, action.payload.variables.id),
        )

        nextState.data?.result?.splice(index, 1)
      })

    case DELETE_FAKE_BRAND.FAIL:
      return produce(state, nextState => {
        const index = findIndex(state?.data?.result, ({ brand }) =>
          areSameValue(brand.id, action.payload.id),
        )

        assign(nextState.data?.result[index], {
          isLoading: false,
          error: action.error.message,
        })
      })

    case UPDATE_BRAND_CURATION_TASK_PERSISTED_FILTERS:
      return produce(state, nextState => {
        assign(nextState.persistedFilters, action.payload)
      })

    default:
      return state
  }
}

export default brandCurationTasksReducer
